export const pageToIndexMapping: {[key: string]: string} = {
}
